import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const galleryImages = [
  { src: '/media/img15.jpg', alt: 'C타입' },
  { src: '/media/img16.jpg', alt: 'B타입' },
  { src: '/media/img17.jpg', alt: 'A타입' },
  { src: '/media/img18.jpg', alt: '쿠폰레슨' },
];

export default function LessonSection() {
  const ref = useScrollAnimation<HTMLDivElement>();

  return (
    <section id="lesson" className="bg-white">
      <div ref={ref} className="scroll-animate py-12 md:py-20 px-4 md:px-6">
        <div className="max-w-6xl mx-auto flex flex-col gap-6 md:gap-8">
          {galleryImages.map((img, i) => (
            <div key={i} className="relative w-full overflow-hidden rounded-lg bg-gray-100">
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}